import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/rootReducer";
import {
	getApplicationInfo,
	getCompanyInfo,
	getCurrentPlan,
} from "@/redux/organization/selector";
import { useEffect } from "react";
import getOrganizationInfoRequestThunk from "@/redux/organization/thunk";
import { setOrganizationInfoFetchState } from "@/redux/organization/actions";

export default function useOrganizationInfoRequestThunk() {
	const dispatch = useDispatch();
	const { isAuthenticated } = useSelector((state: RootState) => state.auth);
	const currentPlan = useSelector(getCurrentPlan);
	const companyInfo = useSelector(getCompanyInfo);
	const applicationInfo = useSelector(getApplicationInfo);

	useEffect(() => {
		if ((!currentPlan || !companyInfo || !applicationInfo) && isAuthenticated) {
			dispatch(getOrganizationInfoRequestThunk());
		}

		return () => {
			dispatch(setOrganizationInfoFetchState("READY"));
		};
	}, [isAuthenticated]);
}
